<div class="welcome__container">
  <h1 class="display-1 mt-4">
    Bem vindo(a) ao <strong>{{ appName }}</strong
    >!
  </h1>
  <p class="welcome__sub-title text-muted text-center">
    Siga os passos para fazer o
    <span class="welcome__highlight-text">onboarding</span> e comece a usar o
    <span class="welcome__highlight-text">{{ appName }}</span
    >!
  </p>
  <img
    class="welcome__background-image"
    src="../../../../../assets/images/welcome.svg"
    alt="bem vindo(a) do RH"
  />

  <div class="welcome__actions">
    <button
      class="welcome__actions-button"
      mat-flat-button
      color="primary"
      (click)="initOnboarding()"
    >
      COMEÇAR
    </button>
  </div>
</div>
